import ValuationRequest from '@/models/valuation/ValuationRequest';
import ValuationResponse from '@/models/valuation/ValuationResponse';
import IVehicleValuationState from './interfaces/vehicle-valuation-state.d';

export default class VehicleValuationState implements IVehicleValuationState {
  public valuationRequest: ValuationRequest = new ValuationRequest();

  public valuationResponse: ValuationResponse = new ValuationResponse();

  public isManualVehicle: boolean = false;

  public moduleKey: string = '';
}
